import React, {useState} from 'react';
import axios from 'axios';
import {
	Box,
	Skeleton,
	Typography,
	ImageList,
	ImageListItem,
	ImageListItemBar, IconButton, Modal
} from '@mui/material';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import {useTranslation} from 'react-i18next';
import {useLoaderData, useLocation} from 'react-router-dom';
import HeaderWithIcons from '@components/app/HeaderWithIcons';
import {appConfig} from '@config';
import {IDynamism, IDynamismCategory} from './DynamismInterface';
// @ts-ignore
import ReactPlayer from 'react-player';
// import ReactPlayerCustom from 'react-player/custom'
// import 'video-react/dist/video-react.css';
// import {Player} from 'video-react';

export default function Dynamism() {
	let dynamisms = useLoaderData() as IDynamism[];
	const {t} = useTranslation();
	const location = useLocation();
	const [dynamismCategory, setDynamismCateogry] = useState<IDynamismCategory | undefined>(location.state);
	const [currentIdx, setCurrentIdx] = useState<number | null>(null); // add a state for the current index
	const [open, setOpen] = useState(false);
	// const renderAction = (dynamism: IDynamism) => {
	// 	let status = <Button component={Link} href={dynamism.winnerLink} className="mx-3">{t('winner_list')}</Button>;
	// 	switch (dynamism.status) {
	// 		case 'enabled':
	// 			status = <Button component={Link} href={dynamism.link} className="mx-3">{t('start_dynamism')}</Button>;
	// 			break;
	// 		case 'remain':
	// 			status = <Typography sx={{color: 'grey.600'}}
	// 			                     className="mx-4">{t('remain_until_start', {day: dynamism.remainDay})}</Typography>;
	// 	}
	// 	return status;
	// };
	
	const handleOpen = (index: number) => {
		setCurrentIdx(index); // set new current index
		setOpen(true);
	};
	
	const handleClose = () => {
		setCurrentIdx(null); // reset current index
		setOpen(false);
	};
	const body = (
		<div className="flex flex-col w-5/6 h-5/6 absolute center border-none justify-center outline-none items-center"
		     onClick={handleClose}>
			{currentIdx !== null && dynamisms[currentIdx] && (
				dynamisms[currentIdx].type === 'image' ? (
						<img
							className="outline-none"
							src={dynamisms[currentIdx].file}
							alt={dynamisms[currentIdx].file}
						/>
					) :
					(
						<ReactPlayer
							className="outline-none"
							playing={true}
							width={'100%'}
							loop={true}
							controls={true}
							url={dynamisms[currentIdx].file}
						/>
					)
			)}
		</div>
	);
	const handleError = (error: any) => {
		console.error('Error playing media:', error);
	};
	return (
		<>
			<HeaderWithIcons title={dynamismCategory?.name ?? <Skeleton className="w-24"/>} home={true}
			                 backUrl={'/dynamisms'}/>
			<Modal
				open={open}
				onClose={handleClose}
				className="w-full h-full border-none"
				keepMounted={true}
				// slots={{ backdrop: Backdrop }}
				slotProps={{
					backdrop: {
						sx: {
							//Your style here....
							backgroundColor: 'rgba(51,51,51,0.84)'
						}
					}
				}}
			>
				<>
					<div className="fixed right-2 top-2 text-white bg-black rounded-3xl">
						<IconButton onClick={handleClose} className="text-white">
							<CloseOutlinedIcon/>
						</IconButton>
					</div>
					{body}
					<Typography sx={{
						fontSize: (theme) => theme.typography.fontSize + 1
					}} className="fixed bottom-0 w-full text-white bg-black text-center p-2">
						{currentIdx !== null && dynamisms[currentIdx].name}
					</Typography>
				</>
			</Modal>
			<div className="flex flex-col space-y-2 px-4">
				{/*<Box className="rounded border flex flex-col mx-4" sx={{*/}
				{/*	borderColor: (theme) => theme.palette.mode === 'light' ? 'grey.100' : 'background.paper',*/}
				{/*	bgcolor: (theme) => theme.palette.mode === 'light' ? 'secondary.A200' : 'grey.700'*/}
				{/*}}>*/}
				<Box sx={{overflowY: 'scroll'}} className="">
					<ImageList
						variant="masonry"
						cols={3}
						gap={3}
					>
						{dynamisms.map((item, index) => (
							<ImageListItem key={item.file} onClick={() => handleOpen(index)}>
								{
									item.type === 'image' ? (
										<img
											srcSet={`${item.file}?w=248&fit=crop&auto=format&dpr=2 2x`}
											src={`${item.file}?w=248&fit=crop&auto=format`}
											alt={item.name}
											loading="lazy"
										/>
									) : (
										<ReactPlayer
											className="react-player rounded-md object-cover w-full h-full"
											playing={false}
											muted
											url={item.file}
											onError={handleError}
											// width={'100%'}
											// height={'auto'}
										/>
									)
								}
								<ImageListItemBar
									// title={item.name}
									subtitle={item.name}
									// position="below"
									// actionIcon={
									// 	<IconButton
									// 		sx={{color: 'rgba(255, 255, 255, 0.54)'}}
									// 		// aria-label={`info about ${item.name}`}
									// 	>
									// 		{/*<InfoIcon/>*/}
									// 	</IconButton>
									// }
								/>
							</ImageListItem>
							// <video
							// 	autoPlay={false}
							// 	preload="none"
							// 	loop
							// 	muted
							// 	poster={item.image}
							// >
							// 	<source
							// 		src={item.image}
							// 		type="video/mp4"
							// 	/>
							// {/*</video>*/}
						))}
					</ImageList>
				</Box>
				{/*{*/}
				{/*	dynamisms ?*/}
				{/*		dynamisms.map((dynamism, index) => {*/}
				{/*				return (*/}
				{/*					<>*/}
				{/*						*/}
				{/*						/!*<Box key={dynamism.id}>*!/*/}
				{/*						/!*	<Box sx={{*!/*/}
				{/*						/!*		bgcolor: (theme) => theme.palette.mode === 'light' ? (dynamism.status === 'enabled' ? 'secondary.50' : '') : (dynamism.status === 'enabled' ? '#272931' : '')*!/*/}
				{/*						/!*	}} className="flex flex-row items-center h-11">*!/*/}
				{/*						/!*		<Typography sx={{color: 'grey.300'}} className="w-8 text-center h-fit">{index + 1}</Typography>*!/*/}
				{/*						/!*		<Typography*!/*/}
				{/*						/!*			sx={{color: (theme) => dynamism.status === 'remain' ? 'grey.400' : (theme.palette.mode === 'light' ? 'grey.800' : 'grey.100')}}*!/*/}
				{/*						/!*			className="grow h-fit">{dynamism.name}</Typography>*!/*/}
				{/*						/!*		{*!/*/}
				{/*						/!*			renderAction(dynamism)*!/*/}
				{/*						/!*		}*!/*/}
				{/*						/!*	</Box>*!/*/}
				{/*						/!*</Box>*!/*/}
				{/*					</>*/}
				{/*				);*/}
				{/*			}*/}
				{/*		) : null*/}
				{/*}*/}
				{/*</Box>*/}
			</div>
		</>
	);
}

interface loader {
	request: Request;
	params: {};
}

export async function dynamismsLoader(data: loader) {
	const res = await axios({
		// @ts-ignore
		url: `${appConfig.dynamisms.url}dynamisms/${data.params.categoryId}`,
		method: 'GET'
	});
	if (res.data.success) {
		return res.data.result;
	} else {
		return res.data.error;
	}
}
